<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { CheckForm } from '~/types/checks'

const { t } = useI18n()
const dialogRef = inject('dialogRef') as any
const checksStore = useChecksStore()
const tablesStore = useTablesStore()
const serversStore = useServersStore()

const checkTypeOptions = [
  { label: t('Dine In'), value: 'dine_in' },
  { label: t('To-Go'), value: 'togo' },
  { label: t('Delivery'), value: 'delivery' },
  { label: t('Third Party'), value: 'third_party' },
  { label: t('Custom'), value: 'custom' },
]

const { tableOptions } = storeToRefs(tablesStore)
const { serverOptions } = storeToRefs(serversStore)

onMounted(async () => {
  await tablesStore.fetchTables()
  await serversStore.fetchServers()
})

async function handleSubmit(formData: CheckForm): Promise<void> {
  const success = await checksStore.createCheck(formData)
  if (success) {
    dialogRef.value?.close()
  }
}
</script>

<template>
  
<FormKitLazyProvider config-file="true">
<FormKit
    id="check-create-form"
    class="flex"
    type="form"
    :actions="false"
    @submit="handleSubmit"
  >
    <div class="flex gap-3 justify-center">
      <div class="w-1/2">
        <FormKit
          type="select"
          :label="t('Check Type')"
          :options="checkTypeOptions"
          validation="required"
          validation-visibility="live"
          name="check_type"
          value="dine_in"
        />
        <FormKit
          type="select"
          :label="t('Table')"
          :options="tableOptions"
          :placeholder="t('Select table')"
          name="table_id"
        />
        <FormKit
          type="select"
          :label="t('Server')"
          :options="serverOptions"
          :placeholder="t('Select server')"
          name="server_id"
        />
        <FormKit
          type="text"
          :label="t('Customer Name')"
          :placeholder="t('Optional')"
          name="customer_name"
        />
        <FormKit
          type="text"
          :label="t('Customer Phone')"
          :placeholder="t('Optional')"
          name="customer_phone"
        />
        <FormKit
          type="number"
          :label="t('Guest Count')"
          validation="required|number|min:1"
          validation-visibility="live"
          name="guest_count"
          value="1"
        />
        <FormKit
          type="textarea"
          :label="t('Notes')"
          :placeholder="t('Optional notes')"
          name="notes"
          rows="3"
        />
        <FormKit
          type="submit"
          :label="t('Add check')"
        />
      </div>
    </div>
  </FormKit>
</FormKitLazyProvider>

</template>
